import styled, { css } from 'styled-components';

import { Spacer } from '@ontruck/orc';

const blockStyles = ({ cellWidth, fullHeight }) => css`
  ${cellWidth &&
  `
    width: ${cellWidth}px;
    min-width: ${cellWidth}px;
  `};
  ${fullHeight &&
  `
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.3;
  `}
`;

const textStyles = ({ textAlign = 'left' }) => css`
  text-align: ${textAlign};
`;

const borderStyles = ({ borderLeft }) =>
  borderLeft &&
  css`
    border-left: 1px solid var(--greyMouse);
  `;

const StyledCell = styled(Spacer).attrs(() => ({
  mRight: 'S',
}))`
  ${blockStyles}
  ${textStyles}
  ${borderStyles}

  .action {
    padding: 0 0.8rem;
    height: 2.4rem;
  }
`;

export default StyledCell;
